export const IBillingAriaStatus = Object.freeze({
  code: "code",
  color: "color",
  label: "label",
  updatedAt: "updated_at",
});

export class BillingAriaStatusModel {
  constructor(data = {}) {
    this[IBillingAriaStatus.code] = data[IBillingAriaStatus.code];
    this[IBillingAriaStatus.color] = data[IBillingAriaStatus.color];
    this[IBillingAriaStatus.label] = data[IBillingAriaStatus.label];
    this[IBillingAriaStatus.updatedAt] = data[IBillingAriaStatus.updatedAt];
  }

  getCode() {
    return this[IBillingAriaStatus.code];
  }

  getColor() {
    return this[IBillingAriaStatus.color];
  }

  getLabel() {
    return this[IBillingAriaStatus.label];
  }

  getUpdatedDate() {
    return this[IBillingAriaStatus.updatedAt];
  }
}
